export class CartItem {
  constructor(
    public index: number,
    public item_id: string,
    public item_name: string,
    public item_category: string,
    public quantity: number,
    public price: number
  ) {}
}

export interface ProductItem {
  id: string;
  name: string;
  category: string;
  quantity: number;
  price: string | undefined;
  promotionId: string;
  promotionName: string;
}

export interface OrderInfo {
  id: string;
  total: string | undefined;
  shipping: string | undefined;
  items: ProductItem[];
}

export enum PageView {
  HOME = '首頁',
  MINI_HOME = '小首頁',
  SALES_EVENT = '限時特惠',
  PRODUCT = '商品頁',
  CATEGORY = '分類',
  CATEGORY_LIST = '分類列表',
  OUTFIT = '穿搭',
  OUTFIT_GRID = '穿搭列表',
  OUTFIT_DETAIL = '穿搭明細',
  NOTIFICATION = '消息中心',
  NOTIFICATION_PROMOTIONS = '優惠活動',
  CART = '購物車',
  SHIPPING = '付款及運送方式',
  PAYMENT = '訂單確認',
  PAYMENT_RESULT = '付款結果',
  FAVORITE = '收藏',
  ARRIVAL = '貨到通知',
  STAGGERED_SHOP_WINDOW = '動態商品館-瀑布流',
  SPECIAL = '動態商品館-特輯',
  SEARCH = '搜尋',
  RATING = '最新評價',

  // 搜尋結果｜動態-商品列表
  SEARCH_RESULT = '搜尋結果',
  CUSTOMER_SERVICE = '客服中心',
  ONLINE_SERVICE = '線上客服',

  // for PRODUCT_CLICK_EVENT
  ORDER_DETAIL = '訂單明細',
  RECEIPT = '發票',
}
